/** Mini App `/app` ostida turadi (vite `base`). */
const APP_PATH = "/app/";

/**
 * Telegram Mini App'ni bosh manzilda ochib qo'ygan bo'lsa, uni to'g'ri
 * manzilga o'tkazadi.
 *
 * Nega kerak: Mini App manzili uch joyda yoziladi (`.env` dagi WEBAPP_URL,
 * @BotFather va nginx). Biror joyda oxiridagi `/app` tushib qolsa, Telegram
 * tanishtiruv saytini ochadi — telefonda odam marketing sahifasini ko'radi,
 * Desktop/Web'da esa `frame-ancestors` tufayli umuman oq sahifa chiqadi va
 * sababi hech qayerda ko'rinmaydi.
 *
 * Telegram ishga tushirish parametrlarini manzil hash'iga qo'yadi
 * (`#tgWebAppData=...`). Shu belgi bor bo'lsa — sahifa Telegram tomonidan
 * ochilgan, demak to'g'ri manzilga o'tkazamiz va hash'ni saqlab qolamiz.
 *
 * `replace` ishlatiladi: brauzer tarixida bo'sh qadam qolmasin.
 */
export function redirectTelegramLaunch(): boolean {
  const { pathname, hash, search } = window.location;

  // Allaqachon Mini App ichidamiz — hech narsa qilmaymiz (aylanmaslik uchun).
  if (pathname.startsWith(APP_PATH)) return false;

  const launched = hash.includes("tgWebAppData=") || search.includes("tgWebAppData=");
  if (!launched) return false;

  window.location.replace(`${APP_PATH}${search}${hash}`);
  return true;
}
